import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FormikProvider, useFormik } from "formik";
import { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import * as Yup from "yup";
import { ApiResponse } from "../../../services/base/apiResponse";

interface AbstractEditDialogProps<T> {
  onDialogClose?: () => void;
  onDialogSubmit?: ((values: Partial<T>) => void) | ((values: ApiResponse<Partial<T>>) => void);
  item: T | null;
  width?: string;
  validationSchema: Yup.ObjectSchema<any>;
  renderForm: (formik: any) => React.ReactNode;
  updateMutation: any;
  header?: string;
}

const AbstractEditDialog = <T extends object>({
  onDialogClose,
  onDialogSubmit,
  width,
  item,
  validationSchema,
  renderForm,
  updateMutation,
  header = "Редактиране",
}: AbstractEditDialogProps<T>) => {
  const [updateItem, { isLoading, isError, isSuccess, reset, data }] = updateMutation;

  const formik = useFormik({
    initialValues: { ...item },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateItem(values);
    },
  });

  useEffect(() => {
    formik.setValues({ ...item });
  }, [item]);

  useEffect(() => {
    if (isSuccess) {
      onDialogSubmit?.(data);
      onDialogClose?.();
      reset?.();
    }
  }, [isSuccess]);

  return (
    <FormikProvider value={formik}>
      <Dialog
        header={header}
        visible={true}
        style={{ width: width ?? "50vw" }}
        footer={
          !isLoading && (
            <>
              <Button
                label="Запази"
                icon="pi pi-check"
                severity="success"
                type="submit"
                raised
                className="font-bold"
                onClick={() => formik.handleSubmit()}
              />
              <Button label="Откажи" icon="pi pi-times" severity="secondary" onClick={onDialogClose} />
            </>
          )
        }
        onHide={() => onDialogClose?.()}
        closeOnEscape
      >
        {isLoading && <ProgressSpinner />}
        {isError && (
          <Message severity="error" text="Възникна грешка при изпращането на заявката." className="w-full mb-4" />
        )}
        {!isLoading && <div className="fluid">{renderForm(formik)}</div>}
      </Dialog>
    </FormikProvider>
  );
};

export default AbstractEditDialog;
